<template>
  <v-row no-gutters class="my-2">
    <v-col cols="12" md="6" lg="4"
      ><div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
        <div class="px-2 py-1">
          <div>Historique de mes transaction</div>
          <div class="text-subtitle-1">pour cet évenement</div>
        </div>
        <div>
          <router-link :to="{ name: 'Historique' }">
            <v-btn color="darkblue" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon icon="mdi-email-plus-outline" size="x-large"></v-icon></v-btn>
          </router-link>
        </div></div
    ></v-col>
    <v-col cols="12" md="6" lg="4"
      ><div class="d-flex sm-gap bg-white bordered justify-space-between ma-md-1 my-1">
        <div class="px-2 py-1">
          <div>Inscrire un nouveau participant</div>
          <div class="text-subtitle-1">à cet évenement</div>
        </div>
        <div>
          <router-link :to="{ name: 'Home' }">
            <v-btn color="darkblue" variant="tonal" elevation="0" block class="h-100 rounded-0"><v-icon icon="mdi-plus" size="x-large"></v-icon></v-btn>
          </router-link>
        </div></div
    ></v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>

